import type { QueryClient } from '@tanstack/react-query';

let generation = 0;
const listeners = new Set<() => void>();

export const authSessionGeneration = {
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  getSnapshot: () => generation,
};

// QueryClient.clear() does not notify mounted observers, so components that outlive the session, such as
// the root session gate and wallet access provider, would keep the previous user's data into the next
// sign-in. A new generation remounts everything under AuthSessionScope.
export const endAuthSession = (queryClient: QueryClient): void => {
  queryClient.clear();
  generation += 1;
  listeners.forEach((listener) => listener());
};
